import Phaser from 'phaser';

import { CONFIG } from './constants';

const game = new Phaser.Game(CONFIG);

game.scene.start('load');
